import React, { useState } from 'react';
import { Card, Button, InputGroup, FormControl, Badge } from 'react-bootstrap';

function Ticket({ ticket, onUpdate, formatPrice }) {
    const [quantity, setQuantity] = useState(0);

    const handleQuantityChange = (change) => {
        const newQuantity = Math.max(0, quantity + change);
        setQuantity(newQuantity);
        onUpdate(ticket.id, newQuantity);
    };

    return (
        <Card className="shadow-sm bg-light text-dark">
            {ticket.limitedAmountLeft && (
                <Badge bg="danger" className="position-absolute" style={{ top: '10px', right: '10px' }}>
                    Nur noch wenige Tickets verfügbar
                </Badge>
            )}
            <Card.Img variant="top" src={ticket.thumbnailUrl} />
            <Card.Body>
                <Card.Title style={{ fontSize: '1.4rem' }} dangerouslySetInnerHTML={{ __html: ticket.title }} />
                <Card.Text style={{ fontSize: '0.9rem', color: 'darkslategray' }} dangerouslySetInnerHTML={{ __html: ticket.caption }} />
            </Card.Body>
            <Card.Footer className="bg-light border-top-0">
                <h4>CHF {formatPrice(ticket.price)}</h4>
                {ticket.orderable ? (
                    <InputGroup className="mb-2">
                        <Button variant="primary" onClick={() => handleQuantityChange(-1)}>-</Button>
                        <FormControl className="text-center" aria-label="Menge" value={quantity} readOnly />
                        <Button variant="primary" onClick={() => handleQuantityChange(1)}>+</Button>
                    </InputGroup>
                ) : (
                    <Card.Text className="text-danger">Nicht verfügbar</Card.Text>
                )}
            </Card.Footer>
        </Card>
    );
}

export default Ticket;